import MessagingBase from './messaging-base';

export default class MessagingMessage extends MessagingBase {
  // Renaming "content" here as it collides with reserved attribute name.
  attrs = {
    text: { key: 'content' },
  };

  serialize() {
    let json = super.serialize(...arguments);

    // The API only accepts content and localId attributes.
    json.data.attributes = {
      content: json.data.attributes.content,
      'local_id': json.data.attributes.local_id,
    };
    return json;
  }
}
